"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareClassService = void 0;
const ShareClassServiceStub_1 = require("./ShareClassServiceStub");
const ShareClassServiceLive_1 = require("./ShareClassServiceLive");
class ShareClassService {
    static create(stub) {
        if (stub) {
            return new ShareClassServiceStub_1.ShareClassServiceStub();
        }
        return new ShareClassServiceLive_1.ShareClassServiceLive();
    }
}
exports.ShareClassService = ShareClassService;
//# sourceMappingURL=ShareClassService.js.map